module.exports = __webpack_public_path__ + "img/IMG_9432_L_Foamcore_MockedUp.9d1fa9e4.jpg";